import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { CustomIcons } from "./CustomIcons";

export const CustomButtonPlusIcon = ({
  handleFunction = () => {},
  icon: Icon,
  text,
  width,
  height,
  marginRight,
  position,
  variant,
  color,
  size,
  id,
  classes,
  fullWidth,
  to,
  aria,
  sxProps = {},
  disabled = false,
}) => {
  const generalStyles = {
    width: width ? width : "18px",
    height: height ? height : "18px",
  };

  return (
    <Button
      disabled={disabled}
      aria-label={aria ? aria : ""}
      className={classes ? classes : "customButtonPlusIcon"}
      component={to ? Link : "button"} //
      to={to || null} //
      fullWidth={!!fullWidth}
      id={id || ""}
      size={size || "small"}
      variant={variant || "outlined"}
      onClick={!to ? handleFunction : undefined}
      startIcon={
        position === "start" ? (
          <CustomIcons icon={Icon} style={generalStyles} />
        ) : null
      }
      endIcon={
        position === "end" ? (
          <CustomIcons icon={Icon} style={generalStyles} />
        ) : null
      }
      color={color || "info"}
      sx={{
        ...sxProps,
      }}>
      {text ? (
        <span className="reOrderTextButton">{text}</span>
      ) : (
        <CustomIcons icon={Icon} style={generalStyles} />
      )}
    </Button>
  );
};
